import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SupplierFile } from 'src/app/models/api/exportador/supplier-file';

@Component({
  selector: 'c-supplier-files-table',
  templateUrl: './supplier-files-table.component.html',
  styleUrls: ['./supplier-files-table.component.scss']
})
export class SupplierFilesTableComponent {

  @Input() dataSource: SupplierFile[] = [];
  /** Conjunto de paths marcados; vive no componente pai, que e quem baixa. */
  @Input() selecionados = new Set<string>();

  @Output() selecionar = new EventEmitter<SupplierFile>();
  @Output() baixar = new EventEmitter<SupplierFile>();
  @Output() visualizar = new EventEmitter<SupplierFile>();

  readonly columns = ['select', 'fileName', 'size', 'created', 'updated', 'actions'];

  estaSelecionado(arquivo: SupplierFile) {
    return this.selecionados.has(arquivo.path);
  }

}
